import {getApiUrl} from "../utils/util-functions";

export const openPageAsync = async (isPreviewMode: boolean) => {
    if (isPreviewMode) {
        return new Promise<any>((resolve) => {
            return {};
        })
    }

    return fetch(getApiUrl() + '/open', {method: 'POST'})
        .then((response) => {
            return response.json();
        })
        .then((response: any) => {
            return response;
        });
}